import { Config } from 'common/config'
import { MenuContext } from 'common/contexts/Menu'
import { useIntersection, useResolution } from 'common/hooks'
import { FlexWrapper } from 'components/Styled/Styled'
import { useContext, useRef } from 'react'
import { Fade } from 'react-awesome-reveal'
import { useTranslation } from 'react-i18next'
import { Component } from '..'
import { Container, Item, NavLinkStyled, StyledGeneralMenu } from './styled'
import { useLocation, useNavigate } from 'react-router-dom'

export const Menu = () => {
  const { t } = useTranslation()
  const { isMinScreen1000 } = useResolution()
  const { setIsOpen } = useContext(MenuContext)
  const navigate = useNavigate()
  const ref = useRef(null)
  const isInteract = useIntersection({ element: ref })
  const { pathname } = useLocation()

  const isBanquetPage = pathname.includes('/banquet')

  const items = [
    {
      title: t('about.us'),
      href: pathname.includes('/banquet') ? '/' : `#${Config.Section.aboutUs}`,
    },
    {
      title: t('other.bookmarks'),
      href: pathname.includes('/banquet')
        ? '/'
        : `#${Config.Section.anotherRestaurants}`,
    },
    {
      title: t('contacts'),
      href: `#${Config.Section.contacts}`,
    },
  ]

  const onItemClick = (item: { title: string; href: string }) => {
    if (isBanquetPage && item.href === '/') {
      navigate('/')
      setIsOpen(false)
      return
    }
    const section = document.getElementById(item.href.replace('#', ''))
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' })
    }
    setIsOpen(false)
  }

  return (
    <>
      <Container ref={ref}>
        {!isMinScreen1000 && <StyledGeneralMenu />}
        <FlexWrapper
          direction="column"
          justify="center"
          gap={isMinScreen1000 ? 56 : 14}>
          <Fade
            cascade
            triggerOnce
            direction="up"
            duration={500}
            damping={0.5}
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              opacity: isInteract ? '1' : '0',
            }}>
            {items.map((item, index) => (
              <NavLinkStyled key={index} onClick={() => onItemClick(item)}>
                <Item>{item.title}</Item>
              </NavLinkStyled>
            ))}
          </Fade>
        </FlexWrapper>
        <Component.Footer />
      </Container>
    </>
  )
}
